import { useContext } from 'react';

import { AuthContext, AuthProps } from '../contexts/Auth.context';

export const useAuth = (): AuthProps => useContext(AuthContext);
